module.exports = __webpack_public_path__ + "media/index.310f5228.mp3";